module.exports = "<div class=\"icons\">\r\n    <span class=\"sort-asc fa fa-caret-up\"></span>\r\n    <span class=\"sort-desc fa fa-caret-down\"></span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/sortable-placeholder/sortable-placeholder.component.html
// module id = ./src/app/shared/components/sortable-placeholder/sortable-placeholder.component.html
// module chunks = main